import React from 'react'
import { usePrinciples, PrinciplesProps } from './usePrinciples'
import styles from './Principles.module.scss'
import TitleSection from 'components/TitleSection/TitleSection'
import PrincipleCard from 'components/PrincipleCard/PrincipleCard'
import AnimatedContainer from 'components/AnimatedContainer/AnimatedContainer'

const Principles: React.FC<PrinciplesProps> = (props: PrinciplesProps) => {
  const { principlesData, isAr, animations, animationsReversed, t } =
    usePrinciples(props)

  return (
    <section id='principles' className={styles.principles}>
      <TitleSection title={t('ourPrinciples')} />
      <div className='container'>
        <div className='row g-4'>
          {principlesData &&
            principlesData.length &&
            principlesData.map((item, index) => (
              <div key={`principle-${item.id}-${index}`} className='col-lg-6'>
                <AnimatedContainer
                  animation={
                    isAr
                      ? animations[index % animations.length]
                      : animationsReversed[index % animationsReversed.length]
                  }
                  extraCssClasses='h-100'
                >
                  <PrincipleCard
                    title={isAr ? item.titleAr : item.titleEn}
                    description={isAr ? item.descriptionAr : item.descriptionEn}
                    icon={item.icon}
                    iconPrefix={item.iconPrefix}
                  />
                </AnimatedContainer>
              </div>
            ))}
        </div>
      </div>
    </section>
  )
}

export default Principles
